import type { CacheBackend } from "@pdfking/compatibility"
import type { TrackingInterface, WireResponse } from "@pdfking/taskmaker"
import type { PdfEngine } from "../types/engine/PdfEngine"
import type { PdfEngineOptions } from "../types/engine/PdfEngineOptions"
import type { EngineTasks } from "../types/tasks/EngineTasks"
import { CreateWorkerEngine as TaskmakerCreateWorkerEngine } from "@pdfking/taskmaker"
import { KeyDrop } from "@pdfking/tfunc"
import { CreateEngineInternal } from "../engine/CreateEngineInternal"

type WorkerEngineOptions = Partial<
  {
    readonly cache: CacheBackend<WireResponse[]>
    readonly worker: string
    readonly workers: number
  } & PdfEngineOptions
>

export const CreateWorkerEngine = (
  config: WorkerEngineOptions = {},
  tracking: TrackingInterface | undefined = undefined
): PdfEngine =>
  CreateEngineInternal(
    TaskmakerCreateWorkerEngine<EngineTasks>({
      worker: config.worker ?? "./receiver.js",
      workers: config.workers,
      cache: config.cache,
      tracking,
    }),
    KeyDrop(config, ["cache", "worker", "workers"])
  )
